import { Component, OnInit, Input, EventEmitter, ViewChild, Output, TemplateRef, ViewContainerRef, ComponentFactoryResolver, ComponentRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { filter, find, findIndex } from 'lodash';
import { LocalDataSource } from 'ng2-smart-table';
import {
  Context,
  Tarea,
  ConfigFinishDefault,
  DynamicComponentForm,
  TaskEvent,
  FuncionDocumento,
  Documento,
  DocumentoDetalle,
  HistorialDocumento,
  RevisionDocumento,
  ConfirmComponent,
  Const,
  DocumentoGenerado,
  TareaAsociacion,
  Static,
  ModificacionDocumento
} from '@app/shared';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DocsConfig } from './shared/modify-document-config.service';
import { DocsDataService } from './shared/modify-document-data.service';
import { ScannerServiceDocs } from './shared/modify-document-scanner.service';


@Component({
  selector: 'iw-modify-document-instance',
  templateUrl: './modify-document.component.html',
  styleUrls: ['./modify-document.component.scss'],
  providers: [DocsDataService, ScannerServiceDocs],
})
export class ModifyDocumentInstanceComponent extends DynamicComponentForm implements OnInit {

  // Contexto del formulario, es suministrado dinámicamente
  @Input() ctx: Context;
  // Evento para finalizar y cerrar la modal, es suministrado dinámicamente
  @Input() event: EventEmitter<any>;
  // Define cuando activar la previsualizacion de informacion de flujo
  @Input() previewFlow = false;
  
  // tipo del proceso de la tarea renderizada
  typeProcess: string;
  // Tarea actual
  task: Tarea;
  // Tarea asociada
  taskAssociation: Array<TareaAsociacion>;
  // Activa el btn de finalizar si hay una opción seleccionada
  isDisabledBtnFinish = true;
  // Determina si el usuario en sesion es responsable de la tarea
  userResponsible = false;
  // Define si la tarea esta finalizada
  finishTask = false;
  // Define si hay una secundaria iniciada
  secondaryActive = false;
  // Extensiones de los archivos permitidas
  extensions: Array<string> = [
    'image/tiff-fx',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/pdf',
    'image/jpg',
    'image/png',
    'image/jpeg',
    'image/tif',
    'image/tiff',
  ];
  // Label de las extensiones permitidas
  extensionsLabel = 'jpg, png, pdf, xlsx, xls, docx, doc, tiff, tif';
  extensionsAccept = '';
   // Define cuando se ve la modifiacion de los documentos
   modifyDocument = true;
   // Revisiones del documento
  reviewDocuments: Array<RevisionDocumento>;
  // Documentos de la tarea de asociacion
  source: Array<Documento> = [];
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Configuracion de la tabla
  settings = {};
  sourceDataHistoryModify: LocalDataSource;
  settingsHistoryModify = {};
  // formulario de respuesta
  formRD: FormGroup = new FormGroup({
    file: new FormControl(null, Validators.required),
    motive: new FormControl('', Validators.required),
  });
  // Nombre documento seleccionado
  documentSelect: Documento;
  // formulario
  formData = new FormData();
  // estdo de la tarea
  statusTask = true;
  // Define cuando se esta realizando una accion en los botones de la tabla
  buttonAction = false;
  // Referencia de la modal
  modalRef: BsModalRef;
  // Informacion de la fila seleccionada de la tabla de docuemntos
  rowSelect: Documento = null;
  // Informacion de la fila seleccionada de la tabla de docuemntos modificados
  rowSelectModify: any = null;
  // objeto de documentos
  documentsUpload: any[] = [];
  // Define ecuando mostrar el combo para la subir documentos
  action = false;
  isLoading = false;
  validModification = false;
  // Documentos descargados
  private _documentsDownload: any[] = [];
  // Documentos generados
  private _documentsGenerated: DocumentoGenerado[] = [];
  //private component: ComponentRef<Ng2FileInputComponent>;
  // se emite cuando se hace la carga de los documentos
  @Output() docsUpload: EventEmitter<any> = new EventEmitter();
  // Se emite cuando se hace la descarga de un documento
  @Output() docsDownload: EventEmitter<any[]> = new EventEmitter();
  // Se emite cuando se hace la previsulizacion de un documento
  @Output() docsPreview: EventEmitter<any[]> = new EventEmitter();
  // Anclaje al contenedor de el componete de subir documentos
  //@ViewChild('componentDocs', { read: ViewContainerRef }) componentDocs: ViewContainerRef;
  // Referencia al componente de confirmación
  @ViewChild('confirmFinish') private confirmFinish: ConfirmComponent;
  // Referencia al template de la modal de visulizacion de documento
  @ViewChild('templatePreviewDoc') private templatePreviewDoc: TemplateRef<any>;
   // Referencia al template de la modal de visulizacion de documento
   @ViewChild('templatePreviewModifyDoc') private templatePreviewModifyDoc: TemplateRef<any>;
  // Referencia al template de la modal de historial de modificaciones de documento
  @ViewChild('historyModify') private historyModify: TemplateRef<any>;
  
  

  constructor(
    //private cfr: ComponentFactoryResolver,
    private toastr: ToastrService,
    private dds: DocsDataService,
    private modalService: BsModalService) {
    super();
  }

  ngOnInit() {
    console.log(this.formRD);  // Should print the FormGroup with the 'file' and 'motive' controls
    console.log(this.formRD.get('file'));
    this.task = this.ctx.task;
    this.taskAssociation = this.task.tarea_asociacion;
    for (let i = 0; i < this.extensions.length; i++) {
      this.extensionsAccept += this.extensions[i];
      if (i !== (this.extensions.length - 1)) {
        this.extensionsAccept += ', ';
      }
    }
    if(this.previewFlow){
      this.finishTask = true;
    }
    this.task = this.ctx.task;
    this.typeProcess = this.ctx.typeProcess;
    if (
      this.task &&
      this.task.tarea_estado &&
      this.task.tarea_estado.nombre === Const.STATUS_TASK.finished
    ) {
      this.finishTask = true;
    }
    if (
      this.task &&
      this.task.tarea_estado &&
      this.task.tarea_estado.nombre === Const.STATUS_TASK.secondaryProgress
    ) {
      this.secondaryActive = true;
    }
    this.formData.append('id_tarea', String(this.task.id));
    const docsC = new DocsConfig(this.statusTask);
    this.settings = docsC.settings;
    docsC.accion.subscribe(async (data: any) => {
      this.buttonAction = true;
      this.accionTable(data);
    });
    this.settingsHistoryModify = docsC.settingsHistoryModify;
    docsC.accionModify.subscribe(async (data: any) => {
      this.accionTableModify(data);
    });
    this.loadingDocs();
    this.validDocs();
  }

  set documentsDownload(docs: any[]) {
    this._documentsDownload = docs;
    this.validDocs();
  }

  get documentsDownload(): any[] {
    return this._documentsDownload;
  }

  set documentsGenerated(docs: DocumentoGenerado[]) {
    this._documentsGenerated = docs;
    this.validDocs();
  }

  get documentsGenerated(): DocumentoGenerado[] {
    return this._documentsGenerated;
  }

  /**
   * Finaliza la tarea
   *
   * @param {boolean} res
   * @memberof ModifyDocumentInstanceComponent
   */
  finish(res: boolean) {
    if (res) {
      const data: ConfigFinishDefault = {
        tarea: this.task.id
      };
      const e: TaskEvent = {
        type: 'finish',
        data: data
      };
      this.event.emit(e);
      this.close();
    }
  }

  /**
   * actualiza la informacion de la tarea con respecto a los documentos subidos
   *
   * @param {*} data
   * @returns {*}
   * @memberof ModifyDocumentInstanceComponent
   */
  documentUpdate(data: Documento[]): any {

    data.forEach(newDoc => {
      // Copiando funciones del documento
      const functionD: FuncionDocumento[] = [];
      newDoc.funciones.forEach(fun => {
        functionD.push({
          funcion: fun.funcion,
          id_funcion: fun.id_funcion,
          obligatorio: fun.obligatorio
        });
      });
      // Copienado documentos detalle del documento
      const detailDocument: DocumentoDetalle[] = [];
      newDoc.documentos_detalle.forEach(detail => {
        // Copiando historial del docuemnto
        const record: HistorialDocumento[] = [];
        if (detail.historial && detail.historial.length) {
          detail.historial.forEach(history => {
            // Copiando revisiones del registro de historial del documento
            const revisions: RevisionDocumento[] = [];
            if (history.revision && history.revision.length) {
              history.revision.forEach(revision => {
                revisions.push({
                  id_revision: revision.id_revision,
                  id_tarea: revision.id_tarea,
                  reponsable_id: revision.reponsable_id,
                  nombre_tarea: revision.nombre_tarea,
                  descripcion: revision.descripcion,
                  nombre_responsable: revision.nombre_responsable,
                  apellidos_responsable: revision.apellidos_responsable,
                  fecha: revision.fecha,
                  revision: revision.revision,
                  historial_id: revision.historial_id,
                  version: revision.version,
                  opcion: revision.opcion
                });
              });
            }
            record.push({
              id: history.id,
              nombre: history.nombre,
              nombre_archivo: history.nombre_archivo,
              extension: history.extension,
              version: history.version,
              revision: revisions,
              radicado: history.radicado,
              tarea_origen: history.tarea_origen
            });
          });
        }
        detailDocument.push({
          fecha: detail.fecha,
          folios: detail.folios,
          historial: record,
          id_documento: detail.id_documento,
          radicado: detail.radicado,
          documento_cita: detail.documento_cita,
          id_documento_cita: detail.id_documento_cita,
        });
      });
      // Copiando documento
      const doc: Documento = {
        clasificacion: newDoc.clasificacion,
        clasificacion_id: newDoc.clasificacion_id,
        codigo_documento: newDoc.codigo_documento,
        documentos_detalle: detailDocument,
        funciones: functionD,
        id_tipo_documental: newDoc.id_tipo_documental,
        id_expediente_cita: newDoc.id_expediente_cita,
        ruta_generacion: newDoc.ruta_generacion,
        ruta_vista_previa: newDoc.ruta_vista_previa,
        tipo_documental: newDoc.tipo_documental,
      };
      this.ctx.task.documentos.forEach((document, index) => {
        if (this.task.id === newDoc.idtarea && document.clasificacion_id === newDoc.clasificacion_id) {
          this.ctx.task.documentos[index] = doc;
        }
      });
      if (this.ctx.task.tarea_asociacion && this.ctx.task.tarea_asociacion.length) {
        this.ctx.task.tarea_asociacion.forEach(taskAssociation => {
          taskAssociation.documentos.forEach((document, index) => {
            if (
              taskAssociation.id_tarea_destino === newDoc.idtarea &&
              document.clasificacion_id === newDoc.clasificacion_id
            ) {
              taskAssociation.documentos[index] = doc;
            }
          });
        });
      }
    });
    this.updateTask(this.ctx.task);
    this.validDocs();
  }

  /**
   * Valida que todos los documentos se hayan subido y activa el boton de finalizar
   *
   * @memberof ModifyDocumentInstanceComponent
   */
  validDocs() {
    this.validModification = false;
    if (this.task.documentos_modificacion.length > 0) {
      this.validModification = true;
    }
    if (this.validModification) {
      this.isDisabledBtnFinish = false;
    } else {
      this.isDisabledBtnFinish = true;
    }
  }

  /**
   * Validad que la tarea se pueda finalizar
   *
   * @memberof ModifyDocumentInstanceComponent
   */
  finishConfirm() {
    if (!this.isDisabledBtnFinish && this.userResponsible && !this.finishTask && !this.secondaryActive) {
      this.confirmFinish.open();
    } else {
      if (!this.userResponsible) {
        this.toastr.error('Usted no posee los permisos suficientes para ejecutar esta acción.', 'Permiso denegado');
      } else if (this.finishTask) {
        this.toastr.error('La tarea ya está finalizada.', 'Acción no permitida');
      } else if (this.secondaryActive) {
        this.toastr.error(
          'No se puede realizar esta acción debido a que se encuentra un procesos secundario en progreso.',
          'Acción no permitida'
        );
      } else if (this.isDisabledBtnFinish) {
          this.toastr.error('Por Favor ingrese toda la información requerida.', 'Información incompleta');
      } else {
        this.toastr.error(
          'Lo sentimos ha ocurrido un error inesperado, inténtalo de nuevo más tarde.',
          'Error inesperado'
        );
      }
    }
  }

  /**
   * Se encarga de controlar el evento de clic en el las filas de la tabla
   *
   * @param {*} data
   * @memberof ModifyDocumentInstanceComponent
   */
  clikRowSelect(data: any) {
    if (this.statusTask && this.userResponsible) {
      this.documentSelect = data.data;
      this.formRD.reset({ file: null, motive: ''});
      this.rowSelect = data.data;
      this.action = true;
    }
  }

    /**
   * Define la accion a realizar dependiendo de la opcion seleccionada en la tabla
   *
   * @private
   * @param {*} data
   * @returns {*}
   * @memberof ModifyDocumentInstanceComponent
   */
    private accionTable(data: any): any {
      if (data.accion === 'download') {
        if (data.data['documento_cita']) {
          const a = document.createElement('a');
          a.href = Const.ROUTES_SYSTEM_INTEGRATIONS.cita.dowloadDocument + data.data['documento_cita'];
          a.click();
          a.remove();
          const indexDownload = findIndex(this.documentsDownload, el => el === data.data['id_documento']);
          if (indexDownload === -1) {
            this.documentsDownload.push(data.data['id_documento']);
            this.docsDownload.emit(this.documentsDownload);
          }
        } else if (data.data['id_documento']) {
          this.download(data.data['id_documento']);
        }
      } else if (data.accion === 'modify') {
        this.getHistoryModify(data.data);
      } else if(data.accion === 'preview'){
        if (data.data['documento_cita']) {
          const a = document.createElement('a');
          a.href = Const.ROUTES_SYSTEM_INTEGRATIONS.cita.dowloadDocument + data.data['documento_cita'];
          a.click();
          a.remove();
          const indexDownload = findIndex(this.documentsDownload, el => el === data.data['id_documento']);
          if (indexDownload === -1) {
            this.documentsDownload.push(data.data['id_documento']);
            this.docsDownload.emit(this.documentsDownload);
          }
        } else if (data.data['id_documento']) {
          this.preview(data.data['id_documento']);
        }
      }
       else if (data.accion === 'error') {
        this.toastr.error(data.message, 'Error de accion');
      }
    }

     /**
   * Define la accion a realizar dependiendo de la opcion seleccionada en la tabla
   *
   * @private
   * @param {*} data
   * @returns {*}
   * @memberof ModifyDocumentInstanceComponent
   */
     private accionTableModify(data: any): any {
      if (data.accion === 'download') {
        this.downloadModify(data.data);
      } else if(data.accion === 'preview'){
          this.previewModify(data.data);
      }
       else if (data.accion === 'error') {
        this.toastr.error(data.message, 'Error de accion');
      }
    }

      /**
   * Desacarga el archivo del documento selecionado
   *
   * @private
   * @param {*} data
   * @returns {*}
   * @memberof ModifyDocumentInstanceComponent
   */
  private download(data: number): any {
    const indexDownload = findIndex(this.documentsDownload, el => el === data);
    if (indexDownload === -1) {
      this.documentsDownload.push(data);
      this.docsDownload.emit(this.documentsDownload);
    }
    this.dds.dowloadFile(data).subscribe((res: any) => {
      const a = document.createElement('a');
      a.target = '_blank';
      a.href = res.file.path;
      a.download = res.file.name;
      a.click();
      a.remove();
    });
  }

/**
   * previsulizar el archivo del documento selecionado
   *
   * @private
   * @param {*} data
   * @returns {*}
   * @memberof ModifyDocumentInstanceComponent
   */
 private preview(data: number): any {
  const indexDownload = findIndex(this.documentsDownload, el => el === data);
  if (indexDownload === -1) {
    this.documentsDownload.push(data);
    this.docsPreview.emit(this.documentsDownload);
  }
  this.dds.dowloadFile(data).subscribe((res: any) => {

    this.modalRef = this.modalService.show(this.templatePreviewDoc, { class:  'modal-personalized', initialState: res.file});
    let type = res.file.path.split(".").pop();
    let document = {"tipo": type, "ruta": res.file.path, "rutaGoogle": "https://docs.google.com/gview?url="+ res.file.path+"&embedded=true",
    "rutaMicrosoft":"https://view.officeapps.live.com/op/view.aspx?src="+res.file.path+"&wdOrigin=BROWSELINK"} 
    this.modalRef.content = document;
  });
}

   /**
   * Desacarga el archivo del documento selecionado
   *
   * @private
   * @param {*} data
   * @returns {*}
   * @memberof ModifyDocumentInstanceComponent
   */
  private downloadModify(data: number): any {
    this.dds.dowloadModifyFile(data).subscribe((res: any) => {
      const a = document.createElement('a');
      a.target = '_blank';
      a.href = res.file.path;
      a.download = res.file.name;
      a.click();
      a.remove();
    });
  }

  /**
   * previsulizar el archivo del documento selecionado
   *
   * @private
   * @param {*} data
   * @returns {*}
   * @memberof ModifyDocumentInstanceComponent
   */
 private previewModify(data: number): any {
  this.dds.dowloadModifyFile(data).subscribe((res: any) => {
    this.modalRef.hide();
    this.modalRef = this.modalService.show(this.templatePreviewModifyDoc, { class:  'modal-personalized', initialState: res.file});
    let type = res.file.path.split(".").pop();
    let document = {"tipo": type, "ruta": res.file.path, "rutaGoogle": "https://docs.google.com/gview?url="+ res.file.path+"&embedded=true",
    "rutaMicrosoft":"https://view.officeapps.live.com/op/view.aspx?src="+res.file.path+"&wdOrigin=BROWSELINK"} 
    this.modalRef.content = document;
  });
}


  /**
   * Setea la data de el componente de revisiones del documento
   *
   * @private
   * @param {*} data
   * @returns {*}
   * @memberof ModifyDocumentInstanceComponent
   */
  private getHistoryModify(data: any): any {
    this.rowSelectModify = data;
    this.modalRef = this.modalService.show(this.historyModify, { class: 'modal-personalized', initialState: data });
    let source: any[] = [];
    this.task.documentos_modificacion.forEach(modify => {
      source.push(modify);
    });
    this.sourceDataHistoryModify = new LocalDataSource(source);
    const docsModify = new DocsConfig(this.statusTask);
    this.settingsHistoryModify = docsModify.settingsHistoryModify;
    docsModify.accionModify.subscribe(async (data: any) => {
      this.accionTableModify(data);
    });
    let modalContent = {
      settingsModify: this.settingsHistoryModify,
      source: this.sourceDataHistoryModify
    };
    this.modalRef.content = modalContent;
  }

    /**
   * Controla los eventos en el componente de subir documentos
   *
   * @param {*} data
   * @returns {*}
   * @memberof ModifyDocumentInstanceComponent
   */
    onAction(data: any): any {
      if (data.action === 1) {
        this.onAdded(data);
      } else if (data.action === 0) {
        this.onRemoved(data);
      }
    }

      /**
   * Controla el evento de remover un archivo del componente de documentos
   *
   * @param {*} data
   * @returns {*}
   * @memberof ModifyDocumentInstanceComponent
   */
  onRemoved(data: any): any {
    if (data.file) {
      this.formRD.get('file').setValue(null);  // Set the selected file to the 'file' FormControl
    };
    this.formData.delete(data.file.name);
    for (let i = 0; i < this.documentsUpload.length; i++) {
      if (this.documentsUpload[i]['file'] === data.file.name) {
        this.documentsUpload.splice(i, 1);
      }
    }
  }

  /**
   * Controla el evento de agregar un archivo del componente de documentos
   *
   * @param {*} data
   * @returns {*}
   * @memberof ModifyDocumentInstanceComponent
   */
  onAdded(data: any): any {
    if (data.file) {
        this.formRD.get('file').setValue(data.file);  // Set the selected file to the 'file' FormControl
      };
    let replace = false;
    for (let i = 0; i < this.documentsUpload.length; i++) {
      if (this.documentsUpload[i]['clasificacion_documento_id'] === this.rowSelect.clasificacion_id) {
        replace = true;
        this.formData.delete(this.documentsUpload[i]['file']);
        this.documentsUpload[i]['file'] = data.file.name;
        break;
      }
    }
    this.formData.append(data.file.name, data.file);
    if (!replace) {
      const dataD = {
        'clasificacion_documento_id': this.rowSelect.clasificacion_id,
        'file': data.file.name,
        'id_tarea': this.rowSelect.idtarea
      };

      if (this.rowSelect.documentos_detalle.length > 0) {
        dataD['id_documento'] = this.rowSelect.documentos_detalle[0].id_documento;
      }
      this.documentsUpload.push(dataD);
    }
  }


  /**
   * Cargar los documentos de la tarea.
   *
   * @memberof ModifyDocumentInstanceComponent
   */
  loadingDocs() {
    this.source = [];
    let modifyDocument: ModificacionDocumento[] = [];
    if(this.task.documentos_modificacion.length > 0){
      modifyDocument = this.task.documentos_modificacion;
    }
    this.taskAssociation.forEach(task => {
      task.documentos.forEach((doc: Documento) => {
        // Copiando funciones del documento
        const functionD: FuncionDocumento[] = [];
        if (doc.funciones && doc.funciones.length) {
          doc.funciones.forEach(fun => {
            functionD.push({
              funcion: fun.funcion,
              id_funcion: fun.id_funcion,
              obligatorio: fun.obligatorio
            });
          });
        }
        // Copiando documentos detalle
        const detailDocument: DocumentoDetalle[] = [];
        if (doc.documentos_detalle && doc.documentos_detalle.length) {
          doc.documentos_detalle.forEach(detail => {
            // Copiando historial
            const record: HistorialDocumento[] = [];
            if (detail.historial && detail.historial.length) {
              detail.historial.forEach(history => {
                record.push({
                  id: history.id,
                  nombre: history.nombre,
                  nombre_archivo: history.nombre_archivo,
                  extension: history.extension,
                  version: history.version,
                  radicado: history.radicado,
                  revision: [],
                });
              });
            }
            detailDocument.push({
              fecha: detail.fecha,
              folios: detail.folios,
              historial: record,
              id_documento: detail.id_documento,
              radicado: detail.radicado,
              documento_cita: detail.documento_cita,
              id_documento_cita: detail.id_documento_cita,
            });
          });
        }
        // Copiando documento
        const document: Documento = {
          clasificacion: doc.clasificacion,
          clasificacion_id: doc.clasificacion_id,
          codigo_documento: doc.codigo_documento,
          documentos_detalle: detailDocument,
          funciones: functionD,
          id_tipo_documental: doc.id_tipo_documental,
          id_expediente_cita: doc.id_expediente_cita,
          ruta_generacion: doc.ruta_generacion,
          ruta_vista_previa: doc.ruta_vista_previa,
          tipo_documental: doc.tipo_documental,
          idtarea: task.id_tarea_destino,
          modificacion: true,
          historial_modificacion : modifyDocument
        };
        this.source.push(document);
      });
    });
    this.sourceData = new LocalDataSource(this.source);
  }


   /**
   * cierra el modal con el la previsualizacion de documento
   *
   * @memberof ModifyDocumentInstanceComponent
   */
   closeModalPreviewDoc() {
    this.modalRef.hide();
  }

  /**
   * cierra el modal con el la previsualizacion de documento
   *
   * @memberof ModifyDocumentInstanceComponent
   */
  closeModalPreviewModifyDoc() {
    this.modalRef.hide();
    this.getHistoryModify(this.rowSelectModify);
  }


  saveResponse() {
    console.log(this.formRD);
    console.log(this.formData);
    this.isLoading = true;
    if (this.formData.has('motive')){
      this.formData.delete('motive');
    }
    this.formData.append('motive', this.formRD.get('motive').value);
    if (this.formData.has('documentos')){
      this.formData.delete('documentos');
    }
    this.formData.append('documentos', JSON.stringify(this.documentsUpload));
    this.dds.modifyDocument(this.formData).subscribe((res: any) => {
      this.isLoading = false;
      if (res.length === 0) {
        console.error('Fallo del sistema');
      } else {
        this.documentsUpload = [];
        delete this.rowSelect;
        this.formData = new FormData();
        this.formData.append('id_tarea', String(this.task.id));
        
        let modifyDocument: ModificacionDocumento[] = this.task.documentos_modificacion;
        let document = find(modifyDocument, {id: res.id});
        if (document){
          document.fecha = res.fecha;
          document.version = res.version;
          document.motivo = res.motivo;
          document.responsable = res.responsable;
          document.responsable_aprobacion = res.responsable_aprobacion;
          document.fecha_aprobacion = res.fecha_aprobacion;
          document.motivo_rechazo = res.motivo_rechazo;
          document.aprobacion = res.aprobacion;
          document.tarea = res.tarea;
          document.documento_modificado = res.documento_modificado;
        }else{
        modifyDocument.push(
          {
            id: res.id,
            fecha: res.fecha,
            version: res.version,
            motivo: res.motivo,
            responsable: res.responsable,
            responsable_aprobacion: res.responsable_aprobacion,
            fecha_aprobacion: res.fecha_aprobacion,
            motivo_rechazo: res.motivo_rechazo,
            aprobacion: res.aprobacion,
            tarea: res.tarea,
            documento_modificado: res.documento_modificado
          }
        );
        }
        this.formRD.get('file').setValue(null);
        this.formRD.get('motive').setValue('');
        this.action = false;
        this.task.documentos_modificacion = modifyDocument;
        this.loadingDocs();
        this.validDocs();
      }
    },
    err => {
      this.isLoading = false;
    });
  }

  

}



// WEBPACK FOOTER //
// ./src/app/forms/all/modify-document/modify-document.component.ts